import { Select, Store } from '@ngxs/store';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AppState } from '../core/store/app.state';
import { Observable, of } from 'rxjs';
import { catchError, switchMap, take, tap } from 'rxjs/operators';
import { McRouter } from '@app/_services';
import { SetGlobalLoading, SetHideSidebar } from '@app/core/store/app.actions';
import { UserHelper } from '@app/_shared/helpers/UserHelper';
import { environment } from '@env/environment.local';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanLoad {
    constructor(private mcRouter: McRouter, private store: Store, private userHelper: UserHelper) {}

    @Select(AppState.isLogged)
    isLogged$: Observable<boolean>;

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.checkLogin().pipe(
            switchMap(() => of(true)),
            catchError(() => of(false))
        );
    }

    canLoad(route: Route): Observable<boolean> {
        return this.checkLogin().pipe(
            switchMap(() => of(true)),
            catchError(() => of(false))
        );
    }

    protected checkLogin(): Observable<boolean> {
        const adminPrefix = this.store.selectSnapshot(AppState.adminPrefix);
        return this.isLogged$.pipe(
            tap((isLogged) => {
                const token = this.userHelper.getUserData()?.token;
                if ((isLogged && token === '') || token === undefined) {
                    // this.redirectToLogin();
                    this.userHelper.logout();
                }
                if (!isLogged) {
                    // this.redirectToLogin();
                    this.userHelper.logout();
                }
            }),
            take(1)
        );
    }

    redirectToLogin() {
        this.store.dispatch([new SetGlobalLoading(true), new SetHideSidebar(true)]);
        const hostName = localStorage.getItem('hostName');
        const esMarcaBlanca = localStorage.getItem('marcaBlanca') === 'true';
        const esPWA = localStorage.getItem('esPWA') === 'true';
        var section = '';
        if (localStorage.getItem('App.lastVisit')) {
            var sUrl = localStorage.getItem('App.lastVisit').split('"')[1];
            section = '&section=' + sUrl;
        } else {
            const sectionSplit = window.location.href.split('admin')[1];
            if (sectionSplit?.length) {
                section = `&section=/admin${sectionSplit}`;
            }
        }

        // window.location.href = `${environment.authPath}/login?destroyedSession=true&host=${hostName}${section}`;

        // Hasta 09/10/24
        // if (environment.name !== 'PROD' && !esMarcaBlanca) {
        //     window.location.href = `${environment.authPath}/login?destroyedSession=true&host=${hostName}${section}`;
        // }

        // if (environment.name === 'PROD' && !esMarcaBlanca) {
        //     window.location.href = `https://micuenta.donweb.com/es-ar/servicios/sitio-simple`;
        //     return;
        // }

        // if (esMarcaBlanca) {
        //     window.location.href = `${environment.marca_blanca.logoutPath}/login?destroyedSession=true&host=${hostName}${section}`;
        // }

        if (environment.name === 'PROD') {
            // Es Prod y Es PWA y Es MB >> https://auth.easybuild.website/login
            // Es Prod y NO Es PWA y Es MB >> https://auth.easybuild.website/login
            // Es Prod y Es PWA y Es SS >> https://auth.sitiosimple.com/login
            // Es Prod y NO Es PWA y Es SS >> https://micuenta.donweb.com/es-ar/servicios/sitio-simple

            if (esMarcaBlanca && esPWA) {
                window.location.href = `https://auth.easybuild.website/login`;
            }

            if (esMarcaBlanca && !esPWA) {
                window.location.href = `https://auth.easybuild.website/login`;
            }

            if (!esMarcaBlanca && esPWA) {
                window.location.href = `https://auth.sitiosimple.com/login`;
            }

            if (!esMarcaBlanca && !esPWA) {
                window.location.href = `https://micuenta.donweb.com/es-ar/servicios/sitio-simple`;
            }
        } else {
            // Es Incu y Es PWA y Es SS >> https://auth.incubator.newss.beer/login
            // Es Incu y Es PWA y Es MB >> http://auth.incubator.erpabruaegne.site/login
            // Es Incu y NO Es PWA y Es SS >> https://auth.incubator.newss.beer/login
            // Es Incu y NO Es PWA y Es MB >> http://auth.incubator.erpabruaegne.site/login

            // Configuracion para NO PROD
            if (!esMarcaBlanca && esPWA) {
                window.location.href = `${environment.authPath}/login?destroyedSession=true&host=${hostName}${section}`;
            }

            if (esMarcaBlanca && esPWA) {
                window.location.href = `${environment.marca_blanca.logoutPath}/login?destroyedSession==true&host=${hostName}${section}`;
            }

            if (!esMarcaBlanca && !esPWA) {
                window.location.href = `${environment.authPath}/login?destroyedSession==true&host=${hostName}${section}`;
            }

            if (esMarcaBlanca && !esPWA) {
                window.location.href = `${environment.marca_blanca.logoutPath}/login?destroyedSession=true&host=${hostName}${section}`;
            }
        }
    }

    // refreshAuthorizationToken(){
    //     this.userHelper.getJWTSessionCookie().pipe(
    //         switchMap((res) => {
    //             if (res) {
    //                 //extract user data and set local or sessionStorage.
    //                 return this.userHelper.checkToken().pipe(
    //                     switchMap((checkTokenRes) => {
    //                         return this.userHelper.setJWTSessionCookie(dataExample);
    //                     }),
    //                     catchError((error) => {
    //                         this.userHelper.logout();
    //                         return of(error);
    //                     })
    //                 );
    //             }
    //         }),
    //         catchError((error) => {
    //             this.userHelper.logout();
    //             return of(error);
    //         })
    //     );
    // }
}
